import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
/**
 * INTER, DI-SELF-HOST — audit kepatuhan Figma F-03 (BERAT).
 *
 * Empat bobot, dua subset, delapan berkas. Bobotnya adalah tepat empat yang
 * `assist-design-tokens.json` nyatakan dan yang Figma pakai: Regular 400, Medium 500,
 * Semi Bold 600, Bold 700. Tidak ada italic — Figma tidak memakainya, dan memuat yang
 * tidak dipakai adalah byte yang dibayar setiap pengguna pabrik di jaringan lambat.
 *
 * `latin-ext` ikut karena naskah Indonesia memakainya lewat nama orang dan tempat
 * (huruf beraksen pada nama pinjaman), dan sebuah glif yang hilang dirender sebagai
 * kotak — kegagalan yang terlihat pengguna, bukan pengembang.
 *
 * DIIMPOR DI SINI, BUKAN DI `index.html`: dengan begitu Vite yang memiliki berkasnya —
 * ia mem-bundel woff2-nya ke `dist/assets/` dengan hash isi, menulis `@font-face`
 * yang menunjuk ke sana, dan `font-display: swap` datang dari @fontsource apa adanya.
 * Sebuah `<link>` ke jaringan luar tidak dapat dibekukan lockfile, tidak dapat
 * di-cache peramban pabrik, dan mengirim alamat IP setiap pengguna ke pihak ketiga
 * pada setiap muat halaman.
 *
 * Urutannya SEBELUM `tokens.css`: `--assist-font-family` menyebut "Inter" lebih dulu,
 * dan sebuah `@font-face` yang terdaftar sesudah pemakaian namanya tetap berlaku —
 * tetapi urutan ini membuat berkas ini terbaca seperti yang terjadi.
 */
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/inter/latin-ext-400.css';
import '@fontsource/inter/latin-ext-500.css';
import '@fontsource/inter/latin-ext-600.css';
import '@fontsource/inter/latin-ext-700.css';
import '@assist/design-tokens/tokens.css';
import '@assist/ui/ui.css';
import './app/console.css';
import { SessionProvider } from './state/session.js';
import { PeriodeProvider } from './state/periode.js';
import { App } from './app/App.js';

const container = document.getElementById('root');
if (!container) throw new Error('#root tidak ada di index.html');

createRoot(container).render(
  <StrictMode>
    <SessionProvider>
      {/* Periode DI DALAM sesi: label bulannya dirender dalam bahasa profil, dan
          bahasa profil hanya ada setelah sesinya ada. */}
      <PeriodeProvider>
        <App />
      </PeriodeProvider>
    </SessionProvider>
  </StrictMode>,
);
